<div class="stick-top">
  <mat-toolbar>
    <mat-icon>key</mat-icon> API Keys
  </mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/apikeys/0">
      <mat-icon>add</mat-icon>
      Create a new API Key
    </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
      <tr>
        <th>
          <div class="vbox">
            Company
            <micro-company-select *ngIf="isCompanyAdmin" [(companyId)]="filter.companyId"></micro-company-select>
          </div>
        </th>
        <th>Name<br/>
          <input [(ngModel)]="filter.name">
        </th>
        <th>
          <div class="vbox">
            API Key<br/>
            <input [(ngModel)]="filter.apiKey">
          </div>
        </th>
        <th>
          <div class="vbox">
            Services
            <micro-service-select [(service)]="filter.service"></micro-service-select>
          </div>
        </th>
        <th>Proxy User
          <micro-user-select [companyId]="filter.companyId" [(userId)]="filter.proxyUserId"></micro-user-select>
        </th>
        <th>
          <div class="vbox">
            Status
            <micro-yesNo-select [(yesNo)]="filter.disabled"
                                yesOption="DISABLED"
                                noOption="ENABLED">
            </micro-yesNo-select>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of dataSource.data">
        <td style="vertical-align: top;">
          <micro-company-lookup [companyId]="element.companyId" [link]="isCompanyAdmin"></micro-company-lookup>
        </td>
        <td style="vertical-align: top;">
          <a routerLink="/apikeys/{{element.id}}">{{element.name}}</a>
        </td>
        <td style="vertical-align: top;">{{element.apiKey}}</td>
        <td style="vertical-align: top;">
          <div *ngFor="let service of element.services">{{service}}</div>
        </td>
        <td style="vertical-align: top;">
          <micro-user-lookup *ngIf="element.proxyUserId"
                             [userId]="element.proxyUserId"
                             [link]="true">
          </micro-user-lookup>
        </td>
        <td style="vertical-align: top;" [ngClass]="element.disabled ? 'CRITICAL' : ''">{{element.disabled ? 'DISABLED' : 'ENABLED'}}</td>
      </tr>
      <tr *ngIf="dataSource.data?.length === 0">
        <td colspan="100"><em>No results found</em></td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td colspan="100">
          <mat-paginator #paginator
                         (page)="reload()">
          </mat-paginator>
        </td>
      </tr>
    </tfoot>
  </table>
</div>
